'use strict'

import 'bootstrap/dist/css/bootstrap.min.css'

import Vue from 'vue'
import Bootstrap from 'bootstrap'

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

window.getCookie = function(cname) {
  let name = cname + '=', cookies = document.cookie.split(';')
  for(let i=0,l=cookies.length; i<l; i++) {
    let c = cookies[i].trim()
    if(c.indexOf(name) === 0) return decodeURIComponent(c.substring(name.length, c.length))
  }
  return null
}
window.setCookie = function(cname, cvalue, expires) {
  if(expires) {
    let d = new Date()
    d.setTime(d.getTime() + (expires * 86400000))
    expires = ';expires=' + d.toUTCString()
  } else {
    expires = ''
  }
  document.cookie = encodeURIComponent(cname)+'=' + encodeURIComponent(cvalue) +  expires
}
window.removeCookie = function(cname) {
  document.cookie = encodeURIComponent(cname)+'=;max-age=0'
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
